if (!customElements.get('component-account-login')) {
customElements.define('component-account-login', class AccountLogin extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const recoverBtn = this.querySelector('.js-show_recover_form_btn');
    if (recoverBtn) {
      recoverBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showRecoverForm();
      });
    }

    const submitBtn = this.querySelector('.js-submit_login_form_btn');
    if (submitBtn) {
      submitBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.submitLoginForm();
      });
    }

    const showLoginFormBtn = this.querySelector('.js-show_login_form_btn');
    if (showLoginFormBtn) {
      showLoginFormBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.showLoginForm();
      });
    }

    const submitRecoverBtn = this.querySelector('.js-submit_recover_password_btn');
    if (submitRecoverBtn) {
      submitRecoverBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.submitRecoverPassword();
      });
    }
  }

  showRecoverForm() {
    this.querySelector('.js-recover_password').classList.add('d-block');
    this.querySelector('.js-recover_password').classList.remove('hidden');
    this.querySelector('.js-login_form').classList.add('hidden');
    this.querySelector('.js-login_form').classList.remove('d-block');
    this.updateFormStatus();
  }

  showLoginForm() {
    this.querySelector('.js-recover_password').classList.add('hidden');
    this.querySelector('.js-recover_password').classList.remove('d-block');
    this.querySelector('.js-login_form').classList.add('d-block');
    this.querySelector('.js-login_form').classList.remove('hidden');
    this.updateFormStatus();
  }

  submitRecoverPassword() {
    const email = document.querySelector('input[name="email"]');
    if (!email || !email.value || !email.checkValidity()) {
      this.updateFormStatus('INVALID');
      return;
    }
    const { origin } = window;

    fetch(`${origin}/account/recover`, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ email: email.value, form_type: 'recover_customer_password' }),
    }).then(() => {
      this.updateFormStatus('OK');
    }).catch((err) => {
      console.error(err);
      this.updateFormStatus('ERROR');
    });
  }

  updateFormStatus(status) {
    ['ERROR', 'OK', 'INVALID'].forEach((key) => {
      this.querySelector(`#formStatus${key}`).classList.add('hidden');
    });

    if (status) {
      this.querySelector(`#formStatus${status}`).classList.add('d-block');
      this.querySelector(`#formStatus${status}`).classList.remove('hidden');
    }
  }

  updateInputStatus(input, status) {
    this.querySelector(`${input}-error`).classList.add('hidden');
    this.querySelector(input).classList.remove('error');
    if (status) {
      this.querySelector(`${input}-error`).classList.add('d-block');
      this.querySelector(input).classList.add('error');
    }
  }

  submitLoginForm() {
    const email = document.querySelector('input[name="customer[email]"]');
    const pass = document.querySelector('input[name="customer[password]"]');
    if (!email || !email.value || !email.checkValidity()) {
      this.updateInputStatus('.input-wrapper-email-field', 'INVALID');
    } else if (!pass || !pass.value || !pass.checkValidity()) {
      this.updateInputStatus('.input-wrapper-password-field', 'INVALID');
    } else {
      this.updateInputStatus('.input-wrapper-email-field');
      this.updateInputStatus('.input-wrapper-password-field');
      // Identify user on Klaviyo
      window.klaviyoIdentify && window.klaviyoIdentify(email.value);
      document.querySelector('#CustomerLogin').submit();
      const domain = window.location.host.includes('trythirdlove') ? 'trythirdlove.com' : 'thirdlove.com';
      jsCookie.set('_tl_is_customer', true, { expires: 18 * 30, domain });
    }
  }
})
}
